import { render, staticRenderFns } from "./CountDownBlock.vue?vue&type=template&id=2a12a167&"
import script from "./CountDownBlock.vue?vue&type=script&lang=js&"
export * from "./CountDownBlock.vue?vue&type=script&lang=js&"
import style0 from "./CountDownBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports